import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthHelper } from '../shared/auth-helper';

@Injectable()
export class BaseGuardGuard implements CanActivate {
  private router: Router;
  constructor(router: Router, private claims: string[]) {
      this.router = router;
   }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      if (AuthHelper.GetUserId() > 0) {
        if (this.claims.length === 0)
        {
          return true;
        }

        var claimsTrue = AuthHelper.CheckClaims(this.claims);

        return claimsTrue;
      }

      // not logged in so redirect to login page with the return url
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
      return false;
  }
}


